import React, { ReactElement, useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Header from '../../components/Header';
import styled from 'styled-components';
import DictionaryBox from '../../components/DictionaryBox';

interface DictionaryItem {
	document_id: string;
	title: string;
	data: string;
}

export default function DiagnosisDictionaryPage(): ReactElement {
	const { title } = useParams<{ title: string }>();
	const [dictionaryData, setDictionaryData] = useState<DictionaryItem[]>([]);
	const [dictionaryItem, setDictionaryItem] = useState<DictionaryItem | null>(null);

	useEffect(() => {
		if (title) {
			axios
				.get(`https://bayawiki.shop/flutterapi/wiki/${title}`, {
					headers: {
						'accept': 'application/json',
						'X-API-Key': 'f04ace13-da9f-4f2c-82bb-37b427ee7469',
					},
				})
				.then((response) => setDictionaryItem(response.data))
				.catch((error) => console.error('Error fetching data:', error));
		} else {
			axios
				.get('https://bayawiki.shop/flutterapi/wiki/type/%EC%9C%84%ED%82%A4?page=1&pageSize=20', {
					headers: {
						'accept': 'application/json',
						'X-API-Key': 'f04ace13-da9f-4f2c-82bb-37b427ee7469',
					},
				})
				.then((response) => setDictionaryData(response.data.data))
				.catch((error) => console.error('Error fetching data:', error));
		}
	}, [title]);

	return (
		<div style={{ width: '100dvw' }}>
			<Header />
			<MainLayout>
				<TitleLayout>
					<SmallTitleText>탈모사전</SmallTitleText>
					<TitleText>
						바야바즈에서 자유롭게
						<br />
						<span style={{ fontWeight: 'bold' }}>모두가 함께 만들어가는 탈모사전</span>
					</TitleText>
				</TitleLayout>
				{title && dictionaryItem ? (
					<DictionaryBox
						key={dictionaryItem.document_id}
						title={dictionaryItem.title}
						imageUrl={
							dictionaryItem.data.match(
								/https:\/\/bayawiki.shop\/image\/[a-zA-Z0-9]+\.[a-z]+/g
							)?.[0] || ''
						}
						context={dictionaryItem.data}
						fullContent={true}
					/>
				) : (
					dictionaryData.map((item, index) => {
						const imageUrlMatch = item.data.match(
							/https:\/\/bayawiki.shop\/image\/[a-zA-Z0-9]+\.[a-z]+/g
						);
						return (
							<DictionaryBox
								key={item.document_id}
								count={index + 1}
								title={item.title}
								imageUrl={imageUrlMatch ? imageUrlMatch[0] : ''}
								context={item.data}
							/>
						);
					})
				)}
			</MainLayout>
		</div>
	);
}

const TitleText = styled.span`
	color: #000;
	text-align: center;
	font-size: 35px;
	font-style: normal;
	font-weight: 300;
	@media (max-width: 768px) {
		font-size: 24px;
	}
`;
const SmallTitleText = styled.span`
	color: #000;
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	@media (max-width: 768px) {
		font-size: 16px;
	}
`;
const MainLayout = styled.div`
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	padding: 125px 0px;
	@media (max-width: 768px) {
		padding: 125px 20px;
		min-height: auto;
	}
`;

const TitleLayout = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	margin-bottom: 60px;
	@media (max-width: 768px) {
		margin-bottom: 40px;
	}
`;
